export const MODAL_NAMES = {
  DEALS_MODAL: 'DEALS_MODAL',
} as const
